export default __webpack_public_path__ + "static/1307-e63c4ee4d54f979c705e9e6ca0331d85.gif";